import React from 'react'

import { useTranslation } from 'react-i18next'

import appConfig from 'app.config'
import { checkIsMobile } from 'shared/utils/helpers'

interface ISddCustomer {
	firstName: string
	lastName: string
	street: string
	houseNumber: string
	postalCode: string
	city: string
	bankInfoList: IBankInfoProps[] | []
}

export interface IBankInfoProps {
	senderVIBAN: string
	senderBIC: string
}

export const CustomerInformationFormSddDE_AT = (data: ISddCustomer) => {
	const { t } = useTranslation(['translation', 'forms'])
	const [isMobile] = React.useState(checkIsMobile())

	const MapIban = (items: IBankInfoProps[]) => {
		let list: any[] = []
		if (items.length !== undefined || items.length !== 0) {
			items.map((item: any) =>
				list.push({ value: item.senderIban, label: item.senderIban })
			)
		} else {
			return list
		}
		return list
	}

	return {
		fieldSetName: '',
		formName: 'CustomerInformationSDD',
		description: '',
		collapsable: false,
		visible: true,
		market: appConfig.country,
		fullSize: true,
		col: 12,
		controls: [
			{
				controlName: 'customer.firstName',
				type: 'text',
				label: t('Firstname'),
				value: data.firstName,
				visible: true,
				fullSize: true,
				col: 12,
				disabled: true,
			},
			{
				controlName: 'customer.lastName',
				type: 'text',
				label: t('Lastname'),
				value: data.lastName,
				visible: true,
				fullSize: true,
				col: 12,
				disabled: true,
			},
			{
				controlName: 'customer.street',
				type: 'text',
				label: t('Street'),
				value: data.street,
				visible: true,
				maxLength: 50,
				col: isMobile ? 12 : 9,
				disabled: true,
			},
			{
				required: false,
				controlName: 'customer.houseNumber',
				type: 'text',
				label: t('Nr'),
				value: data.houseNumber,
				visible: true,
				col: isMobile ? 12 : 3,
				maxLength: 5,
				disabled: true,
			},
			{
				controlName: 'customer.postalCode',
				type: 'number',
				label: t('Zip'),
				value: data.postalCode,
				visible: true,
				col: isMobile ? 12 : 4,
				maxLength: 5,
				disabled: true,
			},
			{
				controlName: 'customer.city',
				type: 'text',
				label: t('City'),
				value: data.city,
				visible: true,
				col: isMobile ? 12 : 8,
				maxLength: 40,
				disabled: true,
			},
			{
				controlName: 'customer-information',
				type: 'text',
				label: '',
				value: '',
				description: t('SDDCustomerDesc'),
				visible: true,
				col: 12,
				disabled: true,
			},
			{
				options: MapIban(data.bankInfoList),
				required: true,
				controlName: 'customer.iban',
				type: 'dropdown',
				label: t('IBAN'),
				placeholder: t('IBAN'),
				value: '',
				description: t('SDDIbanDesc'),
				visible: true,
				col: 12,
				maxLength: 40,
				disabled: false,
			},
		],
	}
}
